/* eslint-disable new-cap */
import config from 'config';
import { appLogger } from 'app-lib/helpers/logging';

const logger = appLogger.create('intercom');
const baseUrl = config.app.baseUrl;

export function initialize(organizer, win = window) {
    if (organizer && organizer.email) {
        try {
            return win.Intercom('boot', {
                app_id: config.intercom.appId,
                name: organizer.name,
                email: organizer.email
            });
        } catch (error) {
            logger.warn('Unable to Initialize Intercom', {error, organizer});
        }
    }
    return null;
}

export function updateKey(channelkey, emailId) {
    if (channelkey && emailId) {
        try {
            return window.Intercom('update', {
                email: emailId,
                channel_Key: channelkey,
                channel_Page: `${baseUrl}/channel/${channelkey}`
            });
        } catch (error) {
            logger.warn('Unable to update key on Intercom', {error, channelkey, emailId});
        }
    }
    return null;
}

export function updateContentCount(contentCount, emailId) {
    if (contentCount && emailId) {
        try {
            return window.Intercom('update', {
                email: emailId,
                channel_Content_Count: contentCount
            });
        } catch (error) {
            logger.warn('Unable to update content count on Intercom', {error, emailId});
        }
    }
    return null;
}

export function updateChannelPrivacy(isLimitedAudience, emailId) {
    const channelPrivacy = isLimitedAudience ? 'private' : 'public';
    if (emailId) {
        try {
            return window.Intercom('update', {
                email: emailId,
                channel_Privacy: channelPrivacy
            });
        } catch (error) {
            logger.warn('Unable to update channel Privacy on Intercom', {error, emailId});
        }
    }
    return null;
}

export function hideIntercomMessenger() {
    try {
        window.Intercom('hide');
    } catch (error) {
        logger.warn('Unable to hide intercom messenger', {error});
    }
}

export function shutdownIntercomMessenger() {
    try {
        window.Intercom('shutdown');
    } catch (error) {
        logger.warn('Unable to shutdown intercom messenger', {error});
    }
}



// WEBPACK FOOTER //
// ./src/app-lib/intercom/intercom.js